import teras from '@/teras'
import router from '../router'



router.beforeEach((to, from, next) => {
   console.log("\nbeforeEach \nfrom: "+from.path+"\nto: "+to.path+"\n\n")
   
   if(!teras.app.ready){
      if(teras.ttl()){
         console.log("TTLCLEAR lancio appClear")
         teras.event.emit('appClear')
      }
      console.log("EFFETTUO LE OPERAZIONI AL PRIMO AVVIO DELLA APP "+ teras.name)
      teras.event.emit('routerFirst', to)
      return true
   }

   if (to.matched.some(record => record.meta.requiresAuth)){
      console.log("SONO RICHIESTI I PERMESSI..... LI CONTROLLO")
      if(teras.app.auth){
         console.log("....PERMESSI VERIFICATI, PROCEDO!")
         next()
      }else{
         console.log("....PERMESSI MANCANTI, LO MANDO A: "+teras.app.routeInitial)
         teras.event.emit('routerNoauth',to)
         next(teras.app.routeNoauth)
      }
   }else{
      console.log("NON SONO RICHIESTI PERMESSI")
      next()
   }

   teras.event.emit('routerChange', to)
})
